"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.repeat = void 0;

/**
 * Return an array of fixed size containing a specified value or function result
 *
 * @tag Array
 * @signature (fn: Function|mixed) => (count:number): Array
 *
 * @param  {Function|mixed}  fn     Function or value to repeat
 * @param  {number}          count  Number of times
 *
 * @return {Array}
 *
 * @example
 * repeat(2)(3)
 * // => [2, 2, 2]
 *
 * repeat(index=>index+1)(3)
 * // => [1, 2, 3]
 */
var repeat = function repeat(fn) {
  return function () {
    var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var result = [];

    for (var i = 0; i < count; i++) {
      result.push(typeof fn === "function" ? fn.call(null, i) : fn);
    }

    return result;
  };
};

exports.repeat = repeat;